import { isValidElement, type HTMLAttributes, type ReactNode } from 'react';
import { anunciarOcultos, Sensivel, textoSensivel } from './sensivel';

/** Texto visível de um nó do React (para o `title` do que a tela corta; r6 visual B3). */
export function textoDoNo(no: ReactNode): string {
  if (no === null || no === undefined || typeof no === 'boolean') return '';
  if (typeof no === 'string' || typeof no === 'number') return String(no);
  if (Array.isArray(no)) return no.map(textoDoNo).filter(Boolean).join(' ');
  // Modo discreto: o texto de <Sensivel> entra no title já censurado.
  if (isValidElement<{ children?: string | null; tipo?: 'texto' | 'nome' }>(no) && no.type === Sensivel) return textoSensivel(no.props.children, no.props.tipo);
  if (isValidElement<{ children?: ReactNode; title?: unknown }>(no)) return typeof no.props.title === 'string' ? no.props.title : textoDoNo(no.props.children);
  return '';
}

type Tag = 'span' | 'p' | 'h1' | 'h2' | 'h3' | 'h4' | 'dd' | 'dt' | 'code' | 'div' | 'li';

/**
 * Texto cortado do núcleo (r7 visual B4): corta numa linha (`truncate`) ou em `linhas` linhas (`line-clamp`) e sempre leva o
 * `title` com o texto inteiro (lido dos filhos, ou `texto` quando o conteúdo não é texto). `tests/texto-cortado.test.ts` barra
 * `truncate` ou `line-clamp` sem `title` fora deste componente.
 */
export function TextoCortado({ como: Elemento = 'span', texto, linhas, className = '', children, ...resto }: { como?: Tag; texto?: string; linhas?: 2 | 3; className?: string; children?: ReactNode } & Omit<HTMLAttributes<HTMLElement>, 'title'>) {
  const corte = linhas === 3 ? 'line-clamp-3' : linhas === 2 ? 'line-clamp-2' : 'truncate';
  const titulo = (texto ?? textoDoNo(children)).trim();
  return (
    <Elemento {...resto} title={titulo || undefined} className={`${corte} ${className}`}>
      {anunciarOcultos(children ?? texto)}
    </Elemento>
  );
}
